import styled from "styled-components";

export const TagTemperatura = styled.div`
  width: auto;
  height: auto;
  min-height: 1.8125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1px 16px 1px 16px;
  border-radius: 1rem;
  font-family: "Inter";
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.125rem;
  letter-spacing: 0px;
`;
